<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading" dark icon title="Export to Excel" @click="downloadToExcel" :loading="loading_download">
                        <v-icon>cloud_download</v-icon>
                    </v-btn>
                    <help-link appId="attendance" pageId="timesheet-review" color="white"></help-link>          
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this timesheet.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="green" dark title="This period is already Closed. You will not be able to change this timesheet.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;"> 
               <v-toolbar flat height="45px">  
                    <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details style="margin-bottom:15px;width:5px;"></v-text-field>                  
                    <v-spacer></v-spacer>  
                    <b>{{selectedPeriod}}</b>                          
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="time_reports_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewUserTimesheet(props.item)" title="Click to view details, approve, reject" style="cursor:pointer;" >
                            <td>
                                <v-chip @click="viewUserProfile(props.item, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="props.item.avatar"></v-img>
                                        </v-avatar>
                                        {{props.item.firstName}} {{props.item.lastName}}
                                    </v-chip>
                            </td>
                            <td>
                                <b v-if="commonfn.getStatusDescription(props.item.status)=='Not Available'" :class="commonfn.getStatusColor(props.item.status)">Unsubmitted</b>
                                <b v-else :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td>
                                <span v-if="props.item.createdOn">{{ props.item.createdOn | moment('MMM DD, YYYY')}}</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>  
</template>

<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import pageKeys from '@/common/pagekeys'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {   
    name: 'Team Timesheet',
    metaInfo: {
        title: 'Team Timesheet',
        meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Team Timesheet' },
                { name: 'viewport', content: 'width=device-width, initial-scale=1' }
                ]
    },   
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'40%', sortable:true},
                {text: 'Timesheet Status', align: 'left', value: 'status', width: '30%', sortable:true},
                {text: 'Created On', align: 'left', value:'createdOn', width: '30%', sortable:true}
            ],
            cutoff_periods: [],
            current_index: 0,
            selected_period: [],
            time_reports: []
        }
    },
    methods: {   
        viewUserTimesheet(data) {
            this.$router.push(`/myteam/timesheet/${this.selectedCutOffId}/${data.userId}`)
        },
        async downloadToExcel() {
            try {
                this.loading_download = true
                const teamId = this.$store.state.selectedTeamId
                const pageKey = pageKeys.timesheet_team_approver
                const response = await timesheetApi.getExcelTeamReport(this.selectedCutOffId, teamId, pageKey)
                const teamName = this.$store.state.selectedTeamName
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `TIMESHEET-${teamName}-${this.selectedPeriod}.xlsx`
                link.click()
                this.loading_download = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTeamTimeReports() {
            try {
                this.loading = true
                const response = await timesheetApi.getTimeReportByTeam(this.selectedCutOffId)              
                if (response && response.status == 200) {
                    this.selected_period = response.data.cutOffItem
                    this.time_reports = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() { 
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Timesheets`
        })

        this.getTeamTimeReports()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        time_reports_filtered() {
            var temp = this.time_reports

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        selectedPeriod() {
            if (this.selected_period)
                return this.$moment(this.selected_period.cutoffStart).format("MMM DD, YYYY") + " - " + this.$moment(this.selected_period.cutoffEnd).format("MMM DD, YYYY") 
            return ''
        },
        frozenPeriod(){
            if (this.selected_period.status)
                return this.selected_period.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.selected_period.status)
                return this.selected_period.status==commonfn.getStatusCode('Closed')
        },
    }
}
</script>